import React from 'react';
import { Link } from "react-router-dom";

// Images
import DisposableMedicalWear from '../../images/DisposableMedica.jpg';
import surgicalconsumable from '../../images/surgical-consumables.png';
import orthopedicimplants from '../../images/orthoimplants.jpg';
import orthopedicconsumables from '../../images/orthopedic-consumables.jpg';

// Section Header
const ProductsHeader = () => (
  <section className="products-header">
    <h2 className="homepage-section-title">Our Products</h2>
  </section>
);

// Single Box Component
const Box = ({ imgSrc, title, description, isReversed, cta }) => (
  <div className={`box ${isReversed ? "reversed" : ""}`}>
    <div className="left">
      <div className="imgbox">
        <img decoding="async" src={imgSrc} alt={title} />
      </div>
    </div>
    <div className="right">
      <div className="contentbox">
        <h2>{title}</h2>
        <p>{description}</p>
      </div>
      {/* CTA outside contentbox */}
      <div className="cta-box">
        <Link to={cta.link} className="homepage-btn-primary">
          {cta.label}
        </Link>
      </div>
    </div>
  </div>
);


// Stats Section
const StatsStrip = () => (
  <div className="stats-strip">
    <div className="stat-item"><strong>300+</strong> Hospitals</div>
    <div className="stat-item"><strong>100+</strong> Products</div>
    <div className="stat-item"><strong>100%</strong> Made in India</div>
    <div className="stat-item"><strong>Custom Packaging</strong></div>
  </div>
);

// CTA Banner
const ContactBanner = () => (
  <div className="contact-banner">
    <h3>Looking for Product Catalogues or Bulk Procurement Details?</h3>
    <Link to="/contact" className="homepage-btn-primary">Contact Sales Team</Link>
  </div>
);

// Optional Placeholder
const AdditionalContentBox = ({ title }) => (
  <div className="box">
    <div className="left">
      <div className="imgbox">
        <img src="https://via.placeholder.com/150" alt={title} />
      </div>
    </div>
    <div className="right">
      <div className="contentbox">
        <h2>{title}</h2>
        <p>Description for {title}</p>
      </div>
    </div>
  </div>
);

// Container for all Boxes
const BoxesContainer = () => {
  const boxesData = [
    {
      imgSrc: DisposableMedicalWear,
      title: "Introducing Our Disposable Medical Wear Collection",
      description:
        "Enhance infection control with our protective apparel — from disposable surgical gowns to drapes and caps. Designed for healthcare workers in high-risk settings, our garments meet CE and ISO quality benchmarks, ensuring full barrier protection without compromising comfort.",
      cta: { label: "Explore More →", link: "/products/disposable-medical-wear-collection" },

    },
    {
      imgSrc: surgicalconsumable,
      title: "Discover Our Surgical Consumables",
      description:
        "Our precision-engineered consumables — like pulse lavage, orthopedic suction, irrigation tips and blades — are developed in-house for critical care and orthopedic use. Built to meet Ayushman Bharat cost ceilings and MDR regulatory norms.",
      cta: { label: "Explore More →", link: "/products/surgical-consumables" },
    },
    {
      imgSrc: orthopedicimplants,
      title: "Orthopedic Implants & Instruments",
      description:
        "We supply a curated portfolio of orthopedic implants and instruments, combining surgical reliability with economic scalability. Our offering spans trauma, spine, and joint segments — all sourced from trusted OEM partners and validated for long-term performance.",
      cta: { label: "Explore More →", link: "/products/orthopedic-implants" },
    },
    {
      imgSrc: orthopedicconsumables,
      title: "Orthopedic Consumables",
      description:
        "From casting and bandages to physiotherapy supports and tapes — our orthopedic consumables help clinics manage post-op care and rehabilitation with ease. Available in bulk-pack, and ready-to-use kits.",
      cta: { label: "Explore More →", link: "/products/orthopedic-consumables" },
    },
  ];

  return (
    <div className="boxes-container">
      {boxesData.map((box, index) => (
        <Box key={index} {...box} isReversed={index % 2 !== 0} />
      ))}
    </div>
  );
};


// Export All as Needed
export {
  ProductsHeader,
  Box,
  BoxesContainer,
  StatsStrip,
  ContactBanner,
  AdditionalContentBox,
};
